const BASE_URL = process.env.REACT_APP_API_URL;
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;

const apiFetch = (path, options = {}) => {
  return fetch(`${BASE_URL}${path}`, {
    ...options,
    headers: {
      'x-client-id': CLIENT_ID,
      ...options.headers,
    },
  });
};

export default apiFetch;
